export default "__VITE_ASSET__CR61DPxE__"